import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { FileText } from "lucide-react";

export function AdminQuoteTemplate() {
  const [text, setText] = useState(null);
  const [saved, setSaved] = useState("");
  useEffect(() => { api.get("/admin/settings").then((r) => { setText(r.data.quote_template || ""); setSaved(r.data.quote_template || ""); }).catch(() => {}); }, []);
  if (text === null) return null;
  const save = async () => {
    const fd = new FormData(); fd.append("quote_template", text);
    try { const r = await api.put("/admin/settings", fd); setText(r.data.quote_template); setSaved(r.data.quote_template); toast.success("Quote template saved"); }
    catch (err) { toast.error(err?.response?.data?.detail || "Could not save"); }
  };
  return (
    <div className="dg-card rounded-xl p-5" data-testid="admin-quote-template">
      <div className="dg-eyebrow flex items-center gap-1"><FileText className="w-3 h-3" /> Installation quote reply template</div>
      <p className="text-sm text-slate-400 mt-2">One tap inserts this into any ticket reply. Put your standard prices in once; the bits in [brackets] are reminders to fill in per job. "[first name]" is filled automatically.</p>
      <textarea className="dg-input mt-3 min-h-[220px] text-sm font-mono" value={text} onChange={(e) => setText(e.target.value)} maxLength={3000} data-testid="quote-template-input" />
      <div className="mt-3 flex items-center gap-3">
        <button type="button" onClick={save} disabled={text === saved} className="dg-btn-primary rounded-full px-5 py-2 text-sm disabled:opacity-40" data-testid="quote-template-save">Save template</button>
        <span className="text-xs text-slate-500">{text.length}/3000</span>
      </div>
    </div>
  );
}
